import { createSlice } from "@reduxjs/toolkit";

/**========================================================================
 *                             initial State
 *
 *
 *
 *
 *========================================================================**/
const initialState = {
  editeModal: false,
  //designerOrderData: [],
  //row select
  designerOrderRowSelect :''
};

/**========================================================================
 *                             Reducer
 *
 *
 *
 *
 *========================================================================**/
const openEditeModal = (state) => {
  state.editeModal = true;
};
const closeEditeModal = (state) => {
  state.editeModal = false;
};

// const orderDataDesignerFeach = (state, action) => {
//   state.designerOrderData = action.payload;
// };

const getDesignerOrderRowSelect =(state, action) =>{
  state.designerOrderRowSelect=action.payload
}

/**========================================================================
 *                             Slice
 *
 *
 *
 *
 *========================================================================**/
const DesignerSlice = createSlice({
  name: "designer",
  initialState,
  reducers: {
    openEditeModal,
    closeEditeModal,
    //orderDataDesignerFeach,
    getDesignerOrderRowSelect,
  },
});

/**========================================================================
 *                             Export
 *
 *
 *
 *
 *========================================================================**/

export const {
  openEditeModal: openEditeModalR,
  closeEditeModal: closeEditeModalR,
  //orderDataDesignerFeach: orderDataDesignerFeachR,
  getDesignerOrderRowSelect:getDesignerOrderRowSelectR,
} = DesignerSlice.actions;

export default DesignerSlice.reducer;
